import '@babel/polyfill';
import $ from 'jquery';
import Swiper from 'swiper/bundle';
import PerfectScrollbar from 'perfect-scrollbar';
import hcSticky from 'hc-sticky';
import setClasses from 'modernizr-esm/src/setClasses';
import flexboxlegacy from 'modernizr-esm/feature/css/flexboxlegacy';
import calc from 'modernizr-esm/feature/css/calc';
import alertify from 'alertifyjs';

import 'swiper/swiper-bundle.css';
import 'perfect-scrollbar/css/perfect-scrollbar.css';
/*import 'bootstrap/js/src/modal';
import 'bootstrap/js/src/collapse';*/
import 'bootstrap/js/src/alert';
import 'sharer.js/sharer.min';
import 'alertifyjs/build/css/alertify.min.css'
import 'isotope-layout/dist/isotope.pkgd.min'

import './js/projects';
import './js/partners';
import './js/header';
import './js/footer';
import './js/customSelect';
import './js/custom/axeptio';
import './index.scss';

var ajaxObject = ajaxObject;
var grecaptcha = grecaptcha;


setClasses([`${flexboxlegacy ? '' : 'no-'}flex`]);
setClasses([`${calc ? '' : 'no-'}calc`]);

new PerfectScrollbar('#search-container', {
    swipeEasing: true,
});

new Swiper('.partners-slider', {
    loop: false,
    slidesPerView: 2,
    spaceBetween: 30,
    navigation: {
        nextEl: '.partners-slider-next',
        prevEl: '.partners-slider-prev',
    },
    breakpoints: {
        576: {
            slidesPerView: 3,
        },
        676: {
            slidesPerView: 4,
        },
        992: {
            slidesPerView: 5,
        },
        1100: {
            slidesPerView: 4,
        },
        1400: {
            slidesPerView: 5,
        },
        1700: {
            slidesPerView: 6,
        },
    },
});

new Swiper('.approvals-slider', {
    loop: false,
    slidesPerView: 1,
    navigation: {
        nextEl: '.approvals-slider-next',
        prevEl: '.approvals-slider-prev',
    },
    breakpoints: {
        344: {
            slidesPerView: 2,
        },
        576: {
            slidesPerView: 3,
        },
        650: {
            slidesPerView: 4,
        },
        1101: {
            slidesPerView: 3,
        },
        1400: {
            slidesPerView: 5,
        }
    },
});

let bannerSlider, jobsSlider, stickyBurger;
const breakPoint = window.matchMedia('(max-width:1100px)');

const bannerSliderFunc = function () {
    bannerSlider = new Swiper('.banner-slider', {
        loop: false,
        pagination: false,
        navigation: false,
        effect: 'fade',
        autoplay: {
            delay: 5000,
        },
        on: {
            slideChange: (e) => {
                const i = e.activeIndex;
                $('.banner-slider-pagination li')
                    .removeClass('active')
                    .eq(i)
                    .addClass('active');
            },
        },
    });

    $('.banner-slider-pagination li').on('click', function () {
        const index = $(this).index();
        bannerSlider.slideTo(index);
    });
};

const jobsSliderFunc = function () {
    jobsSlider = new Swiper('.jobs-slider', {
        loop: false,
        spaceBetween: 30,
        slidesPerView: 3,
        navigation: {
            nextEl: '.jobs-slider-next',
            prevEl: '.jobs-slider-prev',
        },
        breakpoints: {
            1301: {
                slidesPerView: 4,
            },
            1611: {
                slidesPerView: 5,
            },
            2101: {
                slidesPerView: 6,
            },
        },
    });
};

const stickyBurgerFunc = function () {
    stickyBurger = new hcSticky('.menu-opener', {
        stickTo: 'body',
        top: 24,
    });
};

const breakpointChecker = function () {
    if (breakPoint.matches === true) {
        if (bannerSlider !== undefined) {
            bannerSlider.destroy(true, true);
        }

        if (jobsSlider !== undefined) {
            jobsSlider.destroy(true, true);
        }

        stickyBurgerFunc();
    } else if (breakPoint.matches === false) {
        bannerSliderFunc();
        jobsSliderFunc();

        if (stickyBurger !== undefined) {
            stickyBurger.destroy();
        }
    }
};

breakpointChecker();
breakPoint.addListener(breakpointChecker);

const searchMenu = () => {
    $('.menu-opener, .full-search').toggleClass('active');
    $('body').toggleClass('no-scroll');
    $('.site').toggleClass('active');
};

$('.menu-opener, .search-menu-toggle').on('click', function () {
    searchMenu();
});

$('.search-toggle').on('click', function () {
    searchMenu();
    setTimeout(() => {
        $('#full-search-input').focus();
    }, 100);
});

$('.play-button').on('click', function () {
    const button = $(this);
    const id = button.data('id');
    const parent = button.parent().parent();

    const iframe = document.createElement('iframe');

    iframe.setAttribute('frameborder', '0');
    iframe.setAttribute('allowfullscreen', '');
    iframe.setAttribute(
        'src',
        `https://www.youtube.com/embed/${id}?rel=0&showinfo=0&autoplay=1`
    );

    parent.addClass('video-active').html(iframe);
});

// region --------------------------------------------  RGPD FORM SEND ------------------------------------------

//fontion générale
(function () {
    "use strict";

    // definition des parametres de base du plugin
    var options = {
        mail_input_name: 'email',
        retour_message: ".retour_message",
        action: null
    };

    /**
     * @param change_options
     */
    $.fn.VnAjaxForm = function (change_options) {
        alertify.set('notifier', 'position', 'top-center');
        alertify.set('notifier', 'delay', 1000);

        //copy options variable to not overide it
        var option = $.extend(true, {}, options);
        // surcharge main options
        if (change_options) {
            option = $.extend(option, change_options);
        }
        //get form
        var form = $(this);
        //select div to insert into callback message
        var message_container = form.parent().find(option.retour_message);

        option = loadParameters(form, option);

        if (undefined === option.action) {
            alertify.message('No action defined, please contact an administrator');
            return null;
        }

        var timeOut = null; // evite le retour directe du formulaire
        form.submit(function (event) {
            timeOut = setTimeout(function () {
                clearInterval(timeOut);
                message_container.empty(); //on vide le message
                if (form[0].checkValidity() === false) {
                    event.preventDefault();
                    event.stopPropagation();
                    alertify.error(ajaxObjectSarro.require_filed).dismissOthers();
                } else {
                    // fileData = jQuery('#FILE_ATTR_ID').prop('files')[0],
                    var formData = new FormData(form[0]);
                    formData.append('action', option.action);
                    var message_send = null
                    $.ajax({
                        type: 'POST',
                        url: ajaxObjectSarro.ajaxUrl,
                        data: formData,
                        contentType: false,
                        processData: false,
                        dataType: "json",
                        // async:false,
                        beforeSend: function () {
                            var send_point = '...';
                            var index = 0;

                            message_send = alertify.message('<div class="alert alert-info">' + ajaxObjectSarro.send_form_message + ' ' + send_point.substring(0, index % 4) + '</div>', 0, function () {
                                clearInterval(interval);
                            }).dismissOthers();

                            var interval = setInterval(function () {
                                index++;
                                message_send.setContent('<div class="alert alert-info">' + ajaxObjectSarro.send_form_message + ' ' + send_point.substring(0, index % 4) + '</div>');
                            }, 1000);
                        },
                        success: function (jSon_message) {
                            alertify.notify(jSon_message.data.message).dismissOthers();
                            if (jSon_message.success === true) {
                                clearForm(form);
                            }
                        },
                        error: function (data) {
                            alertify.error(ajaxObjectSarro.error).dismissOthers();
                        },
                        complete: function () {
                            message_send.dismiss();
                            try {
                                grecaptcha.reset(); // grecaptcha variable of google reCAPTCHA
                            } catch (error) {
                            }
                        }
                    });
                }
                form.addClass('was-validated');
            }, 200);


            event.preventDefault();
            event.stopPropagation();
        });
    };

    //set default params
    function loadParameters(element, option) {
        if (option.action === null) {
            option.action = $(element).attr('action');
        }
        return option;
    }

})();

function clearForm(form) {
    $(':input', form)
        .not(':button, :submit, :reset, :hidden')
        .val('')
        .prop('checked', false)
        .prop('selected', false);

    form.removeClass('was-validated');
}

function existAndSet(value) {
    return $.inArray(value, [null, undefined, ""]) === -1
}

//endregion
